<template>
  <!--  -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true" >
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入计划名称" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.projectId" placeholder="请选择项目名称" clearable filterable @change="changeProjectId">
            <template #prefix>项目名称</template>
            <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id"/>
          </el-select>
          <el-select v-model="searchInfo.siteId" placeholder="请选择工地名称" clearable filterable @change="changeSiteId($event, searchInfo)">
            <template #prefix>工地名称</template>
            <el-option v-for="item in siteList" :key="item.id" :label="item.siteName" :value="item.id"/>
          </el-select>
          <el-select v-model="searchInfo.classmateId" placeholder="请选择班组名称" clearable filterable @change="changeClassmateId($event, searchInfo)">
            <template #prefix>班组名称</template>
            <el-option v-for="item in classmateList" :key="item.id" :label="item.classmateName" :value="item.id"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="toEdit({})">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="计划名称" prop="templateName" min-width="180rem"/>
          <yq-table-column label="项目名称" prop="projectName" />
          <yq-table-column label="工地名称" prop="siteName" />
          <yq-table-column label="班组名称" prop="classmateName" />
          <yq-table-column label="巡检类型" prop="businessType" >
            <template v-slot="{row}">
              <span v-if="row.businessType === 1">质量巡检</span>
              <span v-else-if="row.businessType === 2">物资巡检</span>
            </template>
          </yq-table-column>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toEditData(row.id)" hasAnyPerms="safety:template:save">编辑</table-button>
                <table-button  el-type="danger" message="是否确认删除数据" @click="toDelete(row.id)" hasAnyPerms="safety:template:delete">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <el-dialog dialog-width="2" title="编辑巡检计划" v-model="showDialog">
      <dialog-table>
        <form-items :data="currentData" ref="formTable" :columns="2" label-width="3rem" icon-width="0">
          <form-item label="计划名称" :required="true" name="templateName" error-message="请输入计划名称">
            <el-input v-model="currentData.templateName" placeholder="请输入计划名称"/>
          </form-item>
          <form-item label="项目名称" :required="true" name="projectId" error-message="请选择项目">
            <el-select v-model="currentData.projectId" placeholder="请选择项目" @change="loadManager">
              <el-option v-for="item in projectList" :key="item.id" :value="item.id" :label="item.projectName"/>
            </el-select>
          </form-item>
          <form-item label="工地名称">
            <el-select v-model="currentData.siteId" placeholder="请选择工地" @change="changeSiteId($event, currentData)">
              <el-option v-for="item in siteList" :key="item.id" :value="item.id" :label="item.siteName"/>
            </el-select>
          </form-item>
          <form-item label="班组名称">
            <el-select v-model="currentData.classmateId" placeholder="请选择班组" @change="changeClassmateId($event, currentData)">
              <el-option v-for="item in classmateList" :key="item.id" :value="item.id" :label="item.classmateName" />
            </el-select>
          </form-item>
          <form-item label="巡检人员">
            <el-select v-model="currentData.userCategoryType" placeholder="请选择" clearable>
              <el-option label="指定人员" :value="2"/>
              <el-option label="指定角色" :value="3"/>
              <el-option label="部门负责人" :value="6"/>
            </el-select>
          </form-item>
          <form-item label="巡检人员">
            <employee-business-type-select v-model="currentData.userIds" :business-type="currentData.userCategoryType"/>
          </form-item>
          <form-item label="负责人">
            <el-select v-model="currentData.manageUserIdsArr" multiple>
              <el-option v-for="item in managerList" :key="item.id" :value="item.id" :label="item.employeeName"/>
            </el-select>
          </form-item>
          <form-item label="注意" :col-span="2">
            <span>巡检人员和负责人必须填写一项，如果同时存在，则都会被指定工作计划</span>
          </form-item>
          <form-item label="巡检周期间隔">
            <el-select v-model="currentData.taskType" placeholder="请选择巡检周期间隔">
              <el-option label="每天" :value="1"/>
              <el-option label="每月" :value="2"/>
              <el-option label="每周" :value="3"/>
            </el-select>
          </form-item>
          <form-item label="巡检时间节点" :required="true" name="taskPeriodArr" error-message="请选择巡检时间节点">
            <el-select v-model="currentData.taskPeriodArr" placeholder="请选择巡检时间节点" multiple>
              <el-option v-for="i in 24" :key="i" :label="getStringForHour(i) + ': 00'" :value="i + ''" v-if="currentData.taskType === 1"/>
              <el-option v-for="i in 30" :key="i" :label="getStringForInt(i) + '号'" :value="i + ''" v-if="currentData.taskType === 2"/>
              <el-option v-for="i in 7" :key="i" :label="getStringWeek(i)" :value="i + ''" v-if="currentData.taskType === 3"/>
            </el-select>
          </form-item>
          <form-item label="巡检方式">
            <el-select v-model="currentData.checkMethod" >
              <el-option :value="1" label="人工巡检"/>
            </el-select>
          </form-item>
          <form-item label="报警方式">
            <el-select v-model="currentData.warnDelay" placeholder="请选择报警方式">
              <el-option :value="0" label="随时报警"/>
              <el-option :value="1" label="定时报警"/>
            </el-select>
          </form-item>
          <form-item label="巡检类型">
            <el-select v-model="currentData.businessType" placeholder="请选择巡检类型">
              <el-option :value="1" label="质量巡检"/>
              <el-option :value="2" label="物资巡检" :disabled="true"/>
            </el-select>
          </form-item>
<!--          <form-item label="状态">-->
<!--            <span v-if="currentData.status === 0">草稿</span>-->
<!--            <span v-else-if="currentData.status === 1">发布</span>-->
<!--          </form-item>-->
          <form-item label="巡检物资" v-if="currentData.businessType === 2" :show-block="true">

          </form-item>
        </form-items>
        <form-tag label="巡检表单配置" >
          <div class="add-new">
            <page-button size="small" el-type="primary" @click="addNewColumn"><yq-icon name="element-ui_plus"/>添加</page-button>
          </div>
        </form-tag>
        <div class="form-column" v-for="(item, idx) in currentData.detailList" :key="idx">
          <el-input class="column-1" v-model="item.columnLabel" placeholder="请添加表单名称"/>
          <el-select class="column-2" v-model="item.columnTypeDisplay" placeholder="请选择表单类型">
            <el-option v-for="(item, idx) in columnTypeDisplay" :key="idx" :label="item.name" :value="item.code"/>
          </el-select>
          <el-switch class="column-3" v-model="item.columnRequire" active-text="必填" inactive-text="选填" :active-value="1" :inactive-value="0"/>
          <table-button class="column-4" el-type="danger" @click="toDeleteDetail(idx)" message="是否确认删除表单内容">删除</table-button>
        </div>

      </dialog-table>
      <template #footer>
        <el-tooltip content="强制删除任务将会清空当天的任务数据，如果不强制删除任务，那么当天的任务不会被清空，设置的任务将在第二天生效">
          <yq-checkbox v-model="currentData.taskForce">
            <span>强制删除任务</span>
            <yq-icon name="element-ui_warning"/>
          </yq-checkbox>
        </el-tooltip>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button @click="saveData" el-type="primary">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import luqiaoCommonApi from "@/api/dz-luqiao/luqiaoCommonApi";
import {useRoute, useRouter} from "vue-router";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import EmployeeBusinessTypeSelect from "@/components/h5/data/EmployeeBusinessTypeSelect.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import safetyTaskTemplateAPI from "@/api/dz-luqiao/safetyTaskTemplateApi";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";
import YqCheckbox from "@/components/h5/data/YqCheckbox.vue";
import YqIcon from "@/components/YqIcon.vue";
import projectUtil from "@/views/h5/luqiao/util/projectUtil";
import Util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqIcon,
    EmployeeBusinessTypeSelect, CCustomSelect, YqCheckbox,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, DialogTable, FormItems, FormItem, FormTag
  },
  data() {
    return {
      searchInfo: {},
      dataList: [{}],
      currentData: {
        taskPeriodArr: [],
        taskForce: 0,
        manageUserIds: "",
        detailList: [],
      },
      showDialog: false,
      projectList: [],
      siteList: [],
      classmateList: [],
      managerList:[],
      columnTypeDisplay: [ // 支持的自定义字段类型
        {name: "文本", code: "text"},
        {name: "日期", code: "date"},
        {name: "数字", code: "number"},
        {name: "图片", code: "image"},
      ],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    this.resetSearch();
    // 加载项目工地数据
    this.projectList = await luqiaoCommonApi.queryProjectNoPage();
    this.classmateList = await luqiaoCommonApi.queryClassmateNoPage();
    this.siteList = await luqiaoCommonApi.querySiteNoPage();
    projectUtil.setProjectInfo(this.projectList, this.siteList, this.classmateList);
  },
  methods: {
    // 数据联动--项目
    changeProjectId(id) {
      projectUtil.changeProjectId(id);
    },
    // 数据联动--工地
    changeSiteId(id, data) {
      let siteInfo = projectUtil.changeSiteId(id);
      if (siteInfo.projectId) {
        data.projectId = siteInfo.projectId;
      }
    },
    // 数据联动--班组
    changeClassmateId(id, data) {
      let c = projectUtil.changeClassmateId(id);
      if (c.siteId) {
        data.siteId = c.siteId;
        data.projectId = c.projectId;
      }
    },
    toDeleteDetail(idx) { // 从列表中移除一条
      this.currentData.detailList.splice(idx, 1);
    },
    queryList() {
      safetyTaskTemplateAPI.queryList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.toalCount;
      });
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toEdit(data) {
      this.currentData = {
        ...data,
        taskForce: 0, //默认不删除数据
        detailList: data.detailList || []
      };
      this.showDialog = true;
    },
    saveData() {
      if (!this.$refs.formTable.validCheck()) {
        return;
      }
      // 巡检时间
      if (this.currentData.taskPeriodArr && this.currentData.taskPeriodArr.length > 0) {
        this.currentData.taskPeriod = this.currentData.taskPeriodArr.join(",");
      }
      // 负责人
      if (this.currentData.manageUserIdsArr && this.currentData.manageUserIdsArr.length > 0) {
        this.currentData.manageUserIds = this.currentData.manageUserIdsArr.join(",");
      }
      safetyTaskTemplateAPI.save(this.currentData).then(() => {
        this.queryList();
        this.showDialog = false;
      })
    },
    // 加载项目下的负责人
    loadManager(projectId) {
      projectUtil.changeProjectId(projectId);
      safetyTaskTemplateAPI.queryManagerList(projectId).then(res => {
        this.managerList = res;
      })
    },
    // 周几
    getStringWeek(i) {
      switch (i) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 3:
          return "周三";
        case 4:
          return "周四";
        case 5:
          return "周五";
        case 6:
          return "周六";
        case 7:
          return "周日";
        default:
          return "";
      }
    },
    getStringForHour(i) {
      let c = i % 24;
      if (c < 10) {
        return "0" + c;
      }
      return c + "";
    },
    getStringForInt(i) {
      if (i < 10) {
        return "0" + i;
      }
      return i + "";
    },
    addNewColumn() {
      this.currentData.detailList.push({columnRequire: false});
    },
    toEditData(id) {
      safetyTaskTemplateAPI.findById(id).then(res => {
        res.taskPeriodArr = res.taskPeriod? res.taskPeriod.split(",") : [];
        res.manageUserIdsArr = res.manageUserIds? res.manageUserIds.split(",") : [];
        res.taskForce = 0;//默认不删除数据
        // 是否有项目、工地、班组，没有就加上,可能是项目已完成等原因导致查询不显示
        this.addNotExistsData(this.projectList, res.projectId, {id: res.projectId, projectName: res.projectName});
        this.addNotExistsData(this.siteList, res.siteId, {id: res.siteId, projectId: res.projectId, siteName: res.siteName});
        this.addNotExistsData(this.classmateList, res.classmateId, {id: res.classmateId, siteId: res.siteId, projectId: res.projectId, classmateName: res.classmateName});
        projectUtil.setProjectInfo(this.projectList, this.siteList, this.classmateList); // 更新项目工地数据
        this.currentData = res;
        this.loadManager(res.projectId);
        this.showDialog = true;
      })
    },
    toDelete(id) {
      safetyTaskTemplateAPI.delete(id).then(() => this.queryList());
    },
    addNotExistsData(list, id, obj) {
      let contains = false;
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          contains = true;
          break;
        }
      }
      if (!contains) {
        list.push(obj);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-column{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 10px;
  .column-1{
    width: 30%;
  }
  .column-2{
    width: 30%;
  }
  .column-3{
    width: auto;
  }
  .column-4{
    width: auto;
  }
}
.add-new{
  text-align: right;
  box-sizing: border-box;
  padding-right: 30px;
}
</style>